<template>
<e-chart ref="chart" />
</template>

<script>
export default {
  name: 'AQIRadarChart',
  props: {
    data: {
      required: true,
      type: Object
    },
    date: {
      required: true,
      type: Number
    }
  },
  methods: {
    setSeries () {
      let {date, data: {series}} = this
      let temp = series.map(el => {
        let data = []
        el.data.forEach((item, i) => {
          if (i === date) {
            data.push(item)
          }
        })

        return {
          ...el,
          data: data
        }
      })
      return temp
    },
    render (isReal) {
      // let {data: {series}} = this
      let series = this.setSeries()
      let temp = series.map(el => {
        let tempData = {
          aqi: [],
          so2: [],
          o3: [],
          co: [],
          pm10: [],
          pm25: [],
          no2: []
        }
        el.data.forEach(item => {
          tempData.aqi.push(item[0])
          tempData.so2.push(item[1])
          tempData.no2.push(item[2])
          tempData.o3.push(item[3])
          tempData.co.push(item[4])
          tempData.pm25.push(item[5])
          tempData.pm10.push(item[6])
        })

        return tempData
      })

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 10,
          data: series.map(el => el.name),
          itemGap: 20,
          textStyle: {
            fontSize: 14
          }
        },
        radar: {
          indicator: [
            { name: 'AQI', max: Math.max(...temp.map(el => el.aqi).flat()) + 10 },
            { name: 'SO2', max: Math.max(...temp.map(el => el.so2).flat()) + 10 },
            { name: 'NO2', max: Math.max(...temp.map(el => el.no2).flat()) + 10 },
            { name: 'O3', max: Math.max(...temp.map(el => el.o3).flat()) + 10 },
            { name: 'CO', max: Math.max(...temp.map(el => el.co).flat()) + 10 },
            { name: 'PM2.5', max: Math.max(...temp.map(el => el.pm25).flat()) + 10 },
            { name: 'PM10', max: Math.max(...temp.map(el => el.pm10).flat()) + 10 }
          ],
          shape: 'circle',
          splitNumber: 5,
          axisLabel: {
            show: true,
            color: 'RGBA(101, 178, 233, 0.4)',
            formatter: function (val) {
              return Number(val.toFixed(0)) === 0 ? '' : Number(val.toFixed(0))
            }
          },
          axisName: {
            color: 'black'
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(11, 12, 12, 0.1)'
            }
          },
          splitArea: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'RGBA(11, 12, 12, 0.2)'
            }
          }
        },
        series: series
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIRadarChart.vue